import { CustomerRole } from '@/types';
import { OrderStatusType } from '@/types/gql/graphql';

export interface FilterSearchProps {
  [key: string]: string | number | number[] | null;
  beginDateAt: string | null;
  endDateAt: string | null;
  orderBy: string;
  createdBy: string;
  q: string;
  companyName: string;
  isShowMy: number;
  companyId: string;
  companyIds: number[];
  id: number;
  offset: number;
  first: number;
}

export interface FilterMoreProps {
  startValue?: string;
  endValue?: string;
  PlacedBy?: string;
  company?: string;
  orderStatus?: string | number;
  orderCancellationStatusCode?: string | number;
}

export const defaultSortKey = 'id';

export const sortKeys = {
  id: 'bcOrderId',
  poNumber: 'poNumber',
  totalIncTax: 'totalIncTax',
  status: 'status',
  placedBy: 'placedBy',
  createdAt: 'createdAt',
  cancellationStatus: 'cancellationStatus',
};

const b2bFilterSearch: FilterSearchProps = {
  q: '',
  companyId: '',
  beginDateAt: null,
  endDateAt: null,
  companyName: '',
  orderBy: `-${sortKeys[defaultSortKey]}`,
  createdBy: '',
  orderNumber: '',
  poNumber: '',
  isShowMy: 0,
  companyIds: [],
  id: 0,
  offset: 0,
  first: 10,
};

const bcFilterSearch = {
  beginDateAt: null,
  endDateAt: null,
  orderBy: `-${sortKeys[defaultSortKey]}`,
  createdBy: '',
  q: '',
};

export const getFilterMoreData = (
  isB2BUser: boolean,
  role: string | number,
  isCompanyOrder: boolean,
  isAgenting: boolean,
  _createdByUsers: any,
  orderStatuses: OrderStatusType[] = [],
  orderCancellationStatusFilterOptions: OrderStatusType[] = [],
) => {
  const newOrderStatuses = orderStatuses.filter(
    (item) => item.statusCode !== '0' && item.statusCode !== '1',
  );
  // const newCancellationStatusFilterOptions = orderCancellationStatusFilterOptions.filter(
  //   (item) => 
  //     item.statusCode !== '2' && 
  //     item.statusCode !== '3' && 
  //     item.statusCode !== '5' &&
  //     item.statusCode !== '6'
  // );
  // const newCreatedByUsers =
  //   createdByUsers?.createdByUser?.results.map((item: any) => ({
  //     createdBy: `${item.firstName} ${item.lastName} (${item.email})`,
  //   })) || [];
  const filterMoreList = [
    {
      name: 'company',
      label: 'Company',
      required: false,
      default: '',
      fieldType: 'text',
      xs: 12,
      variant: 'filled',
      size: 'small',
      idLang: 'orders.company',
    },
    {
      name: 'orderId',
      label: 'Order ID',
      required: false,
      default: '',
      fieldType: 'text',
      xs: 12,
      variant: 'filled',
      size: 'small',
      idLang: 'orders.orderId',
    },
    {
      name: 'orderStatus',
      label: 'Order status',
      required: false,
      default: '',
      fieldType: 'dropdown',
      options: newOrderStatuses,
      replaceOptions: {
        label: 'customLabel',
        value: 'customLabel',
      },
      xs: 12,
      variant: 'filled',
      size: 'small',
      idLang: 'orders.orderStatus',
    },
    {
      name: 'orderCancellationStatus',
      label: 'Order cancellation status',
      required: false,
      default: '',
      fieldType: 'dropdown',
      options: orderCancellationStatusFilterOptions,
      replaceOptions: {
        label: 'customLabel',
        value: 'statusCode',
      },
      xs: 12,
      variant: 'filled',
      size: 'small',
      idLang: 'orders.cancellationStatus',
    },
  ];

  const filterCondition = isB2BUser && !(Number(role) === 3 && !isAgenting);
  const filterCurrentMoreList = filterMoreList.filter((item) => {
    if (
      (!isB2BUser || filterCondition) &&
      !isCompanyOrder &&
      (item.name === 'company' || item.name === 'PlacedBy')
    )
      return false;
    if (Number(role) === 3 && !isAgenting && item.name === 'PlacedBy') return false;
    if (
      (isB2BUser || (Number(role) === CustomerRole.SUPER_ADMIN && isAgenting)) &&
      isCompanyOrder &&
      item.name === 'company'
    )
      return false;
    return true;
  });

  return filterCurrentMoreList;
};

export const getInitFilter = (
  isCompanyOrder: boolean,
  isB2BUser: boolean,
): Partial<FilterSearchProps> => {
  if (isB2BUser) b2bFilterSearch.isShowMy = isCompanyOrder ? 0 : 1;

  return isB2BUser ? b2bFilterSearch : bcFilterSearch;
};

export const currencySymbol = (currencyItem: string) => {
  try {
    if (currencyItem) {
      const currencyToken = JSON.parse(JSON.parse(currencyItem))?.currency_token || '';

      return currencyToken;
    }

    return '';
  } catch (e) {
    return '';
  }
};

export const getOrderStatusText = (status: number | string, getOrderStatuses: any) =>
  getOrderStatuses.find((item: any) => item.systemLabel === status)?.customLabel || '';
